import Sidebar from './Sidebar';
import FeedbackFab from './FeedbackFab';
import { useSidebar } from '../contexts/SidebarContext';
import { useAuthStore } from '../store/authStore';

/**
 * Layout component that wraps protected pages with sidebar navigation
 * Provides consistent layout structure across all authenticated pages
 */
export default function Layout({ children }) {
  const { isCollapsed } = useSidebar();
  const canAccessAdmin = useAuthStore((s) => s.canAccessAdmin);
  const canAccessTenant = useAuthStore((s) => s.canAccessTenant);
  const canAccessClientPortal = useAuthStore((s) => s.canAccessClientPortal);
  const showFeedbackFab = canAccessAdmin?.() || canAccessTenant?.();

  return (
    <div className="app-shell-background min-h-screen flex flex-col">
      {/* Sidebar */}
      <Sidebar />

      {/* Main Content */}
      <main className={`flex-1 flex flex-col pt-16 lg:pt-0 transition-all duration-180 ease-[cubic-bezier(0.2,0.8,0.2,1)] ${isCollapsed ? 'lg:ml-14' : 'lg:ml-64'}`}>
        <div className="flex-1">
          {children}
        </div>
        
        {/* Footer */}
        <footer className="mt-auto border-t border-[var(--ds-border-subtle)] bg-[var(--ds-surface-panel)] py-4">
          <div className="max-w-7xl mx-auto px-6">
            <p className="text-center text-sm text-[var(--ds-text-muted)]">
              {canAccessClientPortal?.() ? (
                <>Powered by SparxMate<span className="ml-2 text-xs opacity-75">v{__APP_VERSION__}</span></>
              ) : (
                <>© {new Date().getFullYear()} SparxMate. All rights reserved. <span className="ml-2 text-xs opacity-75">v{__APP_VERSION__}</span></>
              )}
            </p>
          </div>
        </footer>
      </main>

      {/* Feedback FAB — admin and tenant only */}
      {showFeedbackFab && <FeedbackFab />}
    </div>
  );
}

